import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import Header from "./Header";
import Content from "./Content";

const AddBankDetails = ({ navigation, route }) => {
  return (
    <View style={styles.container}>
      {/* <ScrollView> */}
      <Header params={route.params} navigation={navigation} />
      <Content params={route.params} navigation={navigation} />
      {/* </ScrollView> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f7f7f7",
  },
});

export default AddBankDetails;
